import React, { Ref, useEffect, useRef, useState } from 'react';
import "./style.css"
import { useTheme } from '../../contexts/theme-context';
import Spinner from '../spinner/spiner';
import { includes } from 'lodash';

interface ModalUserbanedProps {
    show: boolean;
    onClose: () => void;
    onConfirm?: (password: string) => void; // Aceita a senha como argumento
    requirePassword?: boolean;
    isLoading: boolean;
    title: string;
    idModal?: string;
    coverMobile?: boolean;
    text?: string;
    errorMessage?: string;
    setPassword: (password: string) => void; // Adicione esta propriedade
    closeRef?: Ref<HTMLButtonElement> | undefined; // Adicione esta propriedade
    extraContent?: React.ReactNode; // Nova prop para HTML opcional
}

const ModalUserbaned: React.FC<ModalUserbanedProps> = ({ idModal, show, onClose, onConfirm, requirePassword, title, text, setPassword, errorMessage, isLoading, closeRef, extraContent, coverMobile = true }) => {
    const [password, setLocalPassword] = useState('');
    const [errorFormmated, setErrorFormatted] = useState('');
    const openModalRef = useRef<HTMLButtonElement | null>(null);
    const closeModalRef = useRef<HTMLButtonElement | null>(null);
    const { isDarkMode } = useTheme();
    const firstRun = useRef(true);

    const handleConfirm = () => {
        if (requirePassword) {
            if(onConfirm) onConfirm(password); // Passa a senha para a função de confirmaçãoa
        } else {
            if(onConfirm) onConfirm(''); // Chama sem a senha
        }
    };

    useEffect(() => {
        if (firstRun.current) {
            firstRun.current = false; // ignora a primeira execução
            return;
        }
            
      if (window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function') {
        window.ReactNativeWebView.postMessage(JSON.stringify({ statusBarStyle: show ? (isDarkMode ? "#181818ff" : "#b4b4b4"): (isDarkMode ? "#000" : "#fff") }));
      }
  }, [show]);

    useEffect(() => {
        if (show)
            openModalRef.current?.click()
        else
            closeModalRef.current?.click()
    }, [show])


    return (
        <>
            {/* <div className={`modal fade`} aria-labelledby="confirmation-modal" aria-hidden="true"> */}
            {/* <div className={`modal modal-password fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none', opacity: show ? '1' : '0'  }} aria-labelledby="confirmation-modal" aria-hidden="true"> */}
            <div className={"modal fade confirmation-modal confirmation-modal-alert"} id={idModal ? idModal : "confirmation-modal"} onClick={() => { setPassword(""); setLocalPassword(""); onClose() }} aria-hidden="true">
                <div className={`modal-dialog ${coverMobile ? "cover-mobile" : "not-cover-mobile"}`}>
                    <div id="username-suggestions"></div>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header" style={{ borderBottom: "0!important", paddingBottom: 0, }}>
                            <h5 className="modal-title" id="modal-post">{title}</h5>
                            <button ref={closeModalRef} type="button" className="btn-close svg-icons-color btn-dark" onClick={() => { setPassword(""); setLocalPassword(""); onClose() }} data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <p dangerouslySetInnerHTML={{ __html: text ?? "" }}/>

                            {title.includes("anúncio") ? (
                                <p>
                                    Acha que foi um engano?
                                    Clique <a href="https://discord.gg/J7XJfrxj" target="_blank" rel="noopener noreferrer">
                                        aqui
                                    </a> entrar em contato.
                                </p>
                            ): (

                                <p>
                                    Acha que seu banimento foi um engano?
                                    Clique <a href="https://forms.gle/h3G8eJGF8ya7ykfn9" target="_blank" rel="noopener noreferrer">
                                        aqui
                                    </a> para pedir a revisão.
                                </p>
                            )}


                            {extraContent}
                            <div className="invalid-feedback invalid-feedback-comment-text" style={{ display: "block" }}>
                                {errorMessage}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button className="d-none" ref={openModalRef} data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target={idModal ? `#${idModal}` : "#confirmation-modal"}>a</button>

        </>

    );
};

export default ModalUserbaned;
